import Api from "./api";

export const getTrackerHTML_URL = (fileNameWithExtension, hash, isInvestorViewer = false, assetId) => {
  try {
    const { username, fullName, role } = JSON.parse(localStorage.getItem("global_user_flag"));
    return `${window.location.origin}/file-viewer.html#${JSON.stringify({
      username,
      fullName,
      role,
      fileNameWithExtension,
      hash,
      domain: Api.url,
      fileServerDomain: Api.url,
      originVoc: Api.origin,
      origin: window.location.origin,
      isInvestorViewer,
      assetId,
    })}`;
  } catch (e) {
    console.log(e);
  }
};

export const getTrackerHTML = (fileNameWithExtension, hash, isInvestorViewer = false, assetId) => {
  try {
    const { username, fullName, role } = JSON.parse(localStorage.getItem("global_user_flag"));
    window.open(
      `${window.location.origin}/file-viewer.html#${JSON.stringify({
        username,
        fullName,
        role,
        fileNameWithExtension,
        hash,
        domain: Api.url,
        fileServerDomain: Api.url,
        originVoc: Api.origin,
        origin: window.location.origin,
        isInvestorViewer,
        assetId,
      })}`,
      "_blank"
    );
  } catch (e) {
    console.log(e);
  }
};
